import React, { useContext } from 'react'

const AppContext= React.createContext();

const AppProvider = ({children}) => {
    let data = {
        fname:"thap",
        lname:"technical"
    }
return <AppContext.Provider value={{...data}}>{children}</AppContext.Provider>
}

const useGlobalContext = () => {
    return useContext(AppContext);
}

export {AppContext ,AppProvider , useGlobalContext}